module.exports = __webpack_public_path__ + "media/img/vca/categories/innovative-f820c4b8d79ceed8823ee25c3480d49b.png";